import ChannelContext from '@jetshop/core/components/ChannelContext';
import React, { useContext, useEffect } from 'react';
import { API_KEY_SKI, API_KEY_MTB } from './LipscoreGlobalThingis';
import styled from 'react-emotion';
import { useScript } from '../../hooks/useScript';
import t from '@jetshop/intl';

const ProductReviewWrapper = styled('div')`
  .lipscore-review-list-footer {
    a {
      display: none;
    }
  }
  .no-reviews {
    display: none;
  }
  [data-ls-product-votes='0'] + .no-reviews {
    display: block;
  }

  .lipscore-review-info-wrapper {
    .lipscore-review-rating-stars-wrapper {
      .lipscore-rating-star {
        fill: black;
        height: 12px;
        width: 12px;
      }
    }
  }

  .lipscore-review-purchase {
    color: #666666;
    .lipscore-review-purchase-icon {
      .lipscore-review-purchase-icon-badge {
        filter: brightness(0%) !important;

        .lipscore-visually-hidden {
        }
      }
    }
  }
`;

export const LipscoreQuestions = ({ product }) => {
  const { selectedChannel } = useContext(ChannelContext);
  const language = selectedChannel?.country?.code?.toLowerCase();
  const currency = selectedChannel?.currency?.name;
  const brand = product?.subName;
  const path = product?.primaryRoute?.path;
  const [loaded, error] = useScript(
    '//static.lipscore.com/assets/' + language + '/lipscore-v1.js'
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (loaded) {
        if (window?.lipscore) {
          if (!window?.lipscore?.isInitialized()) {
            window.lipscoreInit = () => {
              lipscore?.init({
                apiKey: selectedChannel?.id === 1 ? API_KEY_SKI : API_KEY_MTB,
              });
            };
            window.lipscore.apiKey =
              selectedChannel?.id === 1 ? API_KEY_SKI : API_KEY_MTB;
          }
          window.lipscore.initWidgets();
        }
      }
    }
  }, [loaded]);

  if (!loaded || error) return null;

  return (
    <ProductReviewWrapper>
      <div
        id="lipscore-question-post"
        ls-product-name={product?.name}
        ls-brand={brand}
        ls-product-id={product?.id}
        ls-product-url={selectedChannel?.url + path}
        ls-description={product.shortDescription}
        ls-price={product?.price?.incVat}
        ls-price-currency={currency}
      />
      <div
        id="lipscore-question-list"
        ls-product-name={product?.name}
        ls-brand={brand}
        ls-product-id={product?.id}
        ls-product-url={selectedChannel?.url + path}
        ls-description={product.shortDescription}
        ls-price={product?.price?.incVat}
        ls-price-currency={currency}
      />
    </ProductReviewWrapper>
  );
};
